export default "__VITE_ASSET__47a735ed__"